import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private http = inject(HttpClient);
  private bffBaseUrl = environment.bffConfig.url;
  private bffLoginPath = environment.bffConfig.login;
  //private bffLogoutPath = environment.bffConfig.logout;
  private bffUserPath = environment.bffConfig.user;
  
  public getUserInfo(): Observable<any[]> {
    const uri = `${this.bffBaseUrl}${this.bffUserPath}`;
    return this.http.get<any[]>(uri);
  }

  public login(withReturnUrl = true): void {
    const loginEndpoint = `${this.bffBaseUrl}${this.bffLoginPath}`;

    if (withReturnUrl) {
      const currentPath = window.location.pathname + window.location.search;
      const params = new URLSearchParams({ returnUrl: currentPath });
      window.location.href = `${loginEndpoint}?${params.toString()}`;
    } else {
      window.location.href = loginEndpoint;
    }
  }
}